/**
 * User roles collection
 *
 * Contains a list of possible roles a user can have.
 *
 * @type {userRole[]} userRoles
 */
const userRoles = [
  {
    value: 'Waiting for approval',
    key: 'Requester',
    canBePublishedTo: true,
    canBeInvited: true,
    hasTeams: false,
    subscription: {
      message: true,
    },
  },
  {
    value: 'Verified customer',
    key: 'Customer',
    canBePublishedTo: true,
    canBeInvited: true,
    hasTeams: false,
    subscription: {
      message: true,
    },
  },
  {
    value: 'Blocked',
    key: 'Blocked',
    canBeMentioned: false,
    canBeInvited: false,
    hasTeams: false,
    subscription: {
      message: false,
    },
  },
  {
    value: 'Customer Service Agent',
    key: 'CustomerServiceAgent',
    canBeMentioned: true,
    canBeInvited: true,
    hasTeams: true,
    subscription: {
      message: true,
    },
  },
  {
    value: 'Customer Service Manager',
    key: 'CustomerServiceManager',
    canBeMentioned: true,
    canBeInvited: true,
    hasTeams: true,
    subscription: {
      message: true,
    },
  },
  {
    value: 'Field Service Engineer',
    key: 'FieldServiceEngineer',
    canBePublishedTo: true,
    canBeInvited: true,
    hasTeams: false,
    subscription: {
      message: true,
    },
  },
  {
    value: 'Customer Service External',
    key: 'CustomerServiceExternal',
    hasTeams: false,
    subscription: {
      message: false,
    },
  },
  {
    value: 'Customer Service Cooperator',
    key: 'CustomerServiceCooperator',
    canBePublishedTo: true,
    canBeInvited: true,
    hasTeams: false,
    subscription: {
      message: false,
    },
  },
  {
    value: 'Sales',
    key: 'Sales',
    canBePublishedTo: true,
    canBeMentioned: true,
    canBeInvited: true,
    hasTeams: true,
    subscription: {
      message: true,
    },
  },
  {
    value: 'Master Data Administrator',
    key: 'MasterDataAdministrator',
    hasTeams: true,
    subscription: {
      message: true,
    },
  },
  {
    value: 'Instance Administrator',
    key: 'InstanceAdministrator',
    subscription: {
      message: true,
    },
  },
]

export default userRoles
